/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './sticky-header.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/shared/sticky-header/sticky-header.component';
import * as import5 from '../social-share/social-share.component.ngfactory';
import * as import6 from '../../../../app/shared/social-share/social-share.component';
import * as import7 from '../comments/disqus.component.ngfactory';
import * as import8 from '../../../../app/shared/comments/disqus.component';
import * as import9 from '@angular/platform-browser';
const styles_StickyHeaderComponent:any[] = [import0.styles];
export const RenderType_StickyHeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_StickyHeaderComponent,
  data: {}
}
);
export function View_StickyHeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{disqus: 0}),
      (l()(),import1.ɵeld(0,(null as any),(null as any),62,'div',[[
        'class',
        'container-fluid sticky-header fixed-top hidden-sm-down'
      ]
      ],[[
        2,
        'invisible',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),56,'div',[[
        'class',
        'container sticky-header-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),53,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),28,'div',[[
        'class',
        'col-4 sticky-menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),25,'div',[[
        'class',
        'row align-items-center no-gutters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'col-1'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'button',[
      [
        'class',
        'hamburger-button hamburger white-hamburger hamburger--arrow'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'hamburger-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'span',[[
        'class',
        'hamburger-inner hamburger-inner-custom'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-1'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'col-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,29).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'id',
        'sticky_logo'
      ]
      ,
      [
        'src',
        '/images/logo/howmuch-white.png'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'col-8 sticky-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'row align-items-center no-gutters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'col-8'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'col-3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'socialShare',([] as any[]),(null as any),[[
        (null as any),
        'onVisible'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.StickyHeaderComponent = v.component;
      if (('onVisible' === en)) {
        const pd_0:any = ((<any>co.showComments($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_SocialShareComponent_0,import5.RenderType_SocialShareComponent)),
      import1.ɵdid(4767744,[[
        'socialShare',
        4
      ]
    ],0,import6.SocialShareComponent,[
      'isBrowser',
      import1.ElementRef,
      import1.Renderer2
    ]
    ,{
      isHeader: [
        0,
        'isHeader'
      ]
      ,
      twitterText: [
        1,
        'twitterText'
      ]
      ,
      ogTitle: [
        2,
        'ogTitle'
      ]
      ,
      ogDescription: [
        3,
        'ogDescription'
      ]

    }
    ,{onVisible: 'onVisible'}),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'disqus',([] as any[]),(null as any),(null as any),(null as any),import7.View_DisqusComponent_0,import7.RenderType_DisqusComponent)),
    import1.ɵdid(180224,[
      [
        1,
        4
      ]
      ,
      [
        'disqus',
        4
      ]

    ]
    ,0,import8.DisqusComponent,[
      'isBrowser',
      import9.DOCUMENT,
      import1.Renderer2,
      import1.ElementRef
    ]
    ,{
      pageIdentifier: [
        0,
        'pageIdentifier'
      ]
      ,
      pageUrl: [
        1,
        'pageUrl'
      ]
      ,
      shortname: [
        2,
        'shortname'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.StickyHeaderComponent = v.component;
    const currVal_3:any = '/';
    ck(v,29,0,currVal_3);
    const currVal_5:any = false;
    const currVal_6:any = co.twitterText;
    const currVal_7:any = co.ogTitle;
    const currVal_8:any = co.ogDescription;
    ck(v,54,0,currVal_5,currVal_6,currVal_7,currVal_8);
    const currVal_9:any = co.url;
    const currVal_10:any = co.url;
    const currVal_11:any = 'howmuch';
    ck(v,62,0,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    var co:import4.StickyHeaderComponent = v.component;
    const currVal_0:boolean = !co.isVisible;
    ck(v,1,0,currVal_0);
    const currVal_1:any = import1.ɵnov(v,29).target;
    const currVal_2:any = import1.ɵnov(v,29).href;
    ck(v,28,0,currVal_1,currVal_2);
    const currVal_4:any = co.title;
    ck(v,46,0,currVal_4);
  });
}
function View_StickyHeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'stickyHeader',([] as any[]),(null as any),[[
        'window',
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:scroll' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onScroll($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_StickyHeaderComponent_0,RenderType_StickyHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import4.StickyHeaderComponent,[import3.Location],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const StickyHeaderComponentNgFactory:import1.ComponentFactory<import4.StickyHeaderComponent> = import1.ɵccf('stickyHeader',import4.StickyHeaderComponent,View_StickyHeaderComponent_Host_0,{
  url: 'url',
  title: 'title',
  twitterText: 'twitterText',
  ogTitle: 'ogTitle',
  ogDescription: 'ogDescription'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/sticky-header/sticky-header.component.ngfactory.ts